import React, { useState, useEffect, useContext } from 'react';
import { StoreContext } from '../contexts/StoreContext';
import { AuthContext } from '../contexts/AuthContext';
import { Container } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const STORE_API_URL = process.env.REACT_APP_API_URL;

const LocalizationSettings = () => {
  const { token, isAuthenticated } = useContext(AuthContext);
  const { stores, selectedStore, setSelectedStore } = useContext(StoreContext);
  const [localizationSettings, setLocalizationSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAuthenticated && token && selectedStore) {
      fetchLocalizationSettings(selectedStore);
    }
  }, [token, selectedStore]);

  const fetchLocalizationSettings = async (storeId) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${STORE_API_URL}/stores/${storeId}/localization`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error fetching localization settings.');
      }

      const data = await response.json();
      setLocalizationSettings(data || {});
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLocalizationChange = (e) => {
    const { name, value } = e.target;
    setLocalizationSettings((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveLocalizationSettings = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${STORE_API_URL}/stores/${selectedStore}/localization`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ localization: localizationSettings }),
      });

      if (!response.ok) {
        throw new Error('Error updating localization settings.');
      }

      const data = await response.json();
      toast.success(data.message || 'Localization settings updated successfully!');
    } catch (error) {
      toast.error(error.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleStoreChange = (e) => {
    const newStoreId = e.target.value;
    setSelectedStore(newStoreId);
  };

  return (
    <Container>
      <ToastContainer />
      <div className="headline d-flex justify-content-between align-items-center">
        <h2 className="underline">Language Settings</h2>
        <div className="form-group">
          <label></label>
          <select
            id="storeSelect"
            className="form-select"
            value={selectedStore}
            onChange={handleStoreChange}
          >
            <option value="" disabled>Select a store</option>
            {stores.map((store) => (
              <option key={store._id} value={store._id}>
                {store.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {selectedStore && (
        <>
          {loading && <p>Loading...</p>}
          {error && <p className="text-danger">{error}</p>}
          <form onSubmit={handleSaveLocalizationSettings}>
            <div className="form-group">
              <label>Product Type: Sale</label>
              <input
                type="text"
                name="product_type_sale"
                value={localizationSettings.product_type_sale || ''}
                onChange={handleLocalizationChange}
                className="form-control"
                placeholder="e.g., Featured Products"
              />
            </div>
            <div className="form-group">
              <label>Product Type: Affiliate</label>
              <input
                type="text"
                name="product_type_affiliate"
                value={localizationSettings.product_type_affiliate || ''}
                onChange={handleLocalizationChange}
                className="form-control"
                placeholder="e.g., Affiliate Links"
              />
            </div>
            <div className="form-group">
              <label>Product Type: Showcase</label>
              <input
                type="text"
                name="product_type_showcase"
                value={localizationSettings.product_type_showcase || ''}
                onChange={handleLocalizationChange}
                className="form-control"
                placeholder="e.g., Latest Collection"
              />
            </div>
            <div className="form-group">
              <label>Product Type: Services</label>
              <input
                type="text"
                name="product_type_service"
                value={localizationSettings.product_type_service || ''}
                onChange={handleLocalizationChange}
                className="form-control"
                placeholder="e.g., Services Offered"
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Localization Settings'}
            </button>
          </form>
        </>
      )}
    </Container>
  );
};

export default LocalizationSettings;
